import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";

@Component({
  template: `
    <div class="wgu-container">
      <h2>Reset Password</h2>
      <p class="h2">Success! Your account set up has been completed.</p>

      <p class="mb-6">You have successfully setup your new employee account.</p>

      <p class="mb-6">
        You can use your username and password to login to Workday, the
        Intranest and My WGU.
      </p>
    </div>
  `,
  styles: [
    `
      em {
        float: right;
        color: #e05c65;
        padding-left: 10px;
      }
      .error input {
        background-color: #e3c3c5;
      }
      .error ::-webkit-input-placeholder {
        color: #999;
      }
      .error :-moz-placeholder {
        color: #999;
      }
      .error ::-moz-placeholder {
        color: #999;
      }
      .error :ms-input-placeholder {
        color: #999;
      }
    `,
  ],
})
export class SuccessComponent {}
